<script>
import homebox from "@/views/components/homebox.vue"

export default {
  components:{
    homebox
  },
  methods:{
    clickConsult(itemName){
      console.log("123123123")
      this.$emit("clickConsult",itemName)
    },
  }
}
</script>

<template>
<div class="softwarecontainer">
  <div class="title">
    三、智慧油田软件开发产品及服务
  </div>
  <div class="introduce">
    <div>
      <span >提供高效、智能、可靠的全场景油田数智化产品及软件开发支持。</span><br>
      <span style="color: #eb7c31">如想开展进一步的产品展示和交流，请<span class="clickinfo" @click="clickConsult('智慧油田软件开发产品及服务')" style="color:white;background-color: #282d7d;padding: 5px;border-radius: 9px;font-weight: bolder;font-size: 1.1vw">点击咨询</span>。</span>
    </div>
  </div>
  <div class="itemcontainer">
    <div class="item">
      <a href="/softwareOilfield" target="_blank">
        <homebox class="homebox" :title="'智慧油田软件产品'" :imgpath="require('@/assets'+'/software2.png')"></homebox>
      </a>

    </div>
    <div class="item">
      <a href="/softwareCustomized" target="_blank">
      <homebox class="homebox" :title="'软件定制化服务'" :imgpath="require('@/assets'+'/software1.png')"></homebox>
      </a>
    </div>
  </div>
</div>
</template>

<style scoped lang="scss">
.softwarecontainer{
  .title{
    margin: 0 auto;
    text-align: center;
    height: 8.2373300371vh;
    opacity: 1;
    font-size: 2.2vw;
    font-family: Sarial, sans-serif, "Microsoft Yahei";
    font-weight: 700;
    line-height: 4.2373300371vh;
  }
  .introduce{
    font-size: 1.2vw;
    padding: 0 2vw 2vw 2vw;
    line-height: 2vw;
    margin: auto;
    display: flex;
    width: fit-content;
  }
  .itemcontainer{
    display: grid;
    grid-template-columns: minmax(0,1fr) minmax(0,1fr);
    .item{
      padding: 0 3vw;
    }
    .homebox{
      height: 45vh;
    }
  }
}
</style>
